export const personListRoute = '/household?view=persons';
export const personRoute = (personOrgGUID: string) => `/person/${personOrgGUID}` as const;
export const accountRoute = (accountGUID: string) => `/account/${accountGUID}`;
